const keyVersions = "v1.0";

export default keyVersions;
